(() => {
  const selector = [
    '.product-info__description video[data-miralleve-lazy-video="true"]',
    '.product-info__accordion video[data-miralleve-lazy-video="true"]'
  ].join(',');
  const prepared = new WeakSet();

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.dataset.miralleveLoaded !== 'true') {
              video.dataset.miralleveLoaded = 'true';
              video.preload = 'auto';
              video.load();
            }
            if (video.dataset.miralleveAutoplay === 'true') {
              video.play().catch(() => {});
            }
          } else if (video.dataset.miralleveAutoplay === 'true') {
            video.pause();
          }
        });
      }, { rootMargin: '600px 0px', threshold: 0.01 })
    : null;

  function init(root = document) {
    root.querySelectorAll(selector).forEach((video) => {
      if (prepared.has(video)) return;
      prepared.add(video);
      video.autoplay = false;
      video.preload = 'none';
      if (observer) observer.observe(video);
      else video.preload = 'metadata';
    });

    const title = document.querySelector('.product-info h1, h1.product-info__title, h1')?.textContent?.trim();
    root.querySelectorAll('.product-info__description img:not([alt]), .product-info__accordion img:not([alt])')
      .forEach((image, index) => image.setAttribute('alt', title ? `${title} — imagem ${index + 1}` : 'Imagem do produto'));
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
